export default "__VITE_ASSET__ihtjQMPt__"